import React from 'react';
import PropTypes from 'prop-types';
import { styleModifierPropTypes } from 'styled-components-modifiers';

import TextField from '@material-ui/core/TextField';
import { InputStyled, modifiers } from './Input.styled';

const Input = ({
  id,
  name,
  value,
  placeholder,
  required,
  onChange,
  onKeyPress,
  onKeyDown,
  onBlur,
  modifiers,
  label,
  type,
  variant,
  error,
  helperText,
  form,
  field,
  autoComplete,
  autoFocus,
  inputMode,
  pattern,
  dataNw,
  accept,
}) => {
  const inputName = name || field.name;
  const inputValue = value || field.value;
  const inputChange = onChange || field.onChange;
  const inputTouched = form.touched[inputName];
  const formError = form.errors[inputName];
  const errorMessage = ((inputTouched || autoFocus) && (error || formError)) || null;
  const hasError = !!errorMessage;

  const handleBlur = (ev) => {
    !!onBlur && onBlur(ev, form.values);
    field.onBlur && field.onBlur(ev);
  };

  return (
    <InputStyled modifiers={modifiers}>
      <TextField
        id={id}
        variant={variant}
        type={type}
        label={label}
        name={inputName}
        value={inputValue}
        onChange={inputChange}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        onBlur={handleBlur}
        required={required}
        error={hasError}
        helperText={errorMessage || helperText}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        inputProps={{ inputMode, pattern, 'data-nw': dataNw, accept }}
      />
    </InputStyled>
  );
};

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  type: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  inputMode: PropTypes.string,
  pattern: PropTypes.string,
  variant: PropTypes.string,
  required: PropTypes.bool,
  autoFocus: PropTypes.bool,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    values: PropTypes.object,
  }),
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  modifiers: styleModifierPropTypes(modifiers),
  dataNw: PropTypes.string,
};

Input.defaultProps = {
  error: null,
  required: false,
  autoFocus: false,
  onKeyPress: null,
  onKeyDown: null,
  variant: 'standard',
  form: {
    touched: {},
    errors: {},
    values: {},
  },
  field: {
    name: '',
    value: '',
    onChange: null,
    onBlur: null,
  },
};

export default Input;
